import { 
    tableReportsConstants
} from "./constants"
import api from "./api"
import {
	defAction
}from "../../../helpers/defaultAction"
import downloadFile from "../../../helpers/downloadFile";

export const tableReportsActions = {
    getSettingsListForReportGenerator,
	generateTableReport,
	clearSettingsListForReportGenerator,
	getRegionsListForReportGenerator,
	getDistrictsListForReportGenerator,
	getRegionCitiesListForReportGenerator,
	getSubthemesListForReportGenerator,
	getThemesListForReportGenerator,
	getAppealTypesListForReportGenerator,
	getAppealViewTypesListForReportGenerator,
	getReOrgAppealStatusesListForReportGenerator,
	getAppealFormTypesListForReportGenerator,
	getApplicantTypesListForReportGenerator,
	getReOrgsListForReportGenerator,
	getReOrgAppealTerritoriesListForReportGenerator,
	getSuperiorOrgsListForReportGenerator,
	getReceptionPersonListForReportGenerator,
	getControlCompleteStatusesListForReportGenerator,
	getAllReOrgReportSettingsList,
	getCurrentReOrgReportSetting,
	createReOrgReportSetting,
	updateReOrgReportSetting,
	deleteReOrgReportSetting,
	clearCRUDResultForReportGenerator,
	clearCurrentReOrgReportSetting,
	clearReOrgsListForReportGenerator,
	clearAllReOrgReportSettingsList
}

function getSettingsListForReportGenerator(){
	const dispatchObj = {
		constants : tableReportsConstants.getSettingsListForReportGenerator,
		service   : {
			func   : api.getSettingsListForReportGenerator
		}
	}
	return defAction(dispatchObj)
}

function generateTableReport(params, file){
	const dispatchObj = {
		constants : tableReportsConstants.generateReport,
		service   : {
			func   : api.generateReport,
			params : params
		},
		sucFunction: (response) => {
			downloadFile(response, file)
		}
	}
	return defAction(dispatchObj)
}

function getRegionsListForReportGenerator(){
	const dispatchObj = {
		constants : tableReportsConstants.getRegionsListForReportGenerator,
		service   : {
			func   : api.getRegionsListForReportGenerator
		}
	}
	return defAction(dispatchObj)
}

function getDistrictsListForReportGenerator(){
	const dispatchObj = {
		constants : tableReportsConstants.getDistrictsListForReportGenerator,
		service   : {
			func   : api.getDistrictsListForReportGenerator
		}
	}
	return defAction(dispatchObj)
}

function getRegionCitiesListForReportGenerator(){
	const dispatchObj = {
		constants : tableReportsConstants.getRegionCitiesListForReportGenerator,
		service   : {
			func   : api.getRegionCitiesListForReportGenerator
		}
	}
	return defAction(dispatchObj)
}

function getSubthemesListForReportGenerator(){
	const dispatchObj = {
		constants : tableReportsConstants.getSubthemesListForReportGenerator,
		service   : {
			func   : api.getSubthemesListForReportGenerator
		}
	}
	return defAction(dispatchObj)
}

function getThemesListForReportGenerator(){
	const dispatchObj = {
		constants : tableReportsConstants.getThemesListForReportGenerator,
		service   : {
			func   : api.getThemesListForReportGenerator
		}
	}
	return defAction(dispatchObj)
}

function getAppealTypesListForReportGenerator(){
	const dispatchObj = {
		constants : tableReportsConstants.getAppealTypesListForReportGenerator,
		service   : {
			func   : api.getAppealTypesListForReportGenerator
		}
	}
	return defAction(dispatchObj)
}

function getAppealViewTypesListForReportGenerator(){
	const dispatchObj = {
		constants : tableReportsConstants.getAppealViewTypesListForReportGenerator,
		service   : {
			func   : api.getAppealViewTypesListForReportGenerator
		}
	}
	return defAction(dispatchObj)
}

function getReOrgAppealStatusesListForReportGenerator(){
	const dispatchObj = {
		constants : tableReportsConstants.getReOrgAppealStatusesListForReportGenerator,
		service   : {
			func   : api.getReOrgAppealStatusesListForReportGenerator
		}
	}
	return defAction(dispatchObj)
}

function getAppealFormTypesListForReportGenerator(){
	const dispatchObj = {
		constants : tableReportsConstants.getAppealFormTypesListForReportGenerator,
		service   : {
			func   : api.getAppealFormTypesListForReportGenerator
		}
	}
	return defAction(dispatchObj)
}

function getApplicantTypesListForReportGenerator(){
	const dispatchObj = {
		constants : tableReportsConstants.getApplicantTypesListForReportGenerator,
		service   : {
			func   : api.getApplicantTypesListForReportGenerator
		}
	}
	return defAction(dispatchObj)
}

function getReOrgsListForReportGenerator(params){
	const dispatchObj = {
		constants : tableReportsConstants.getReOrgsListForReportGenerator,
		service   : {
			func   : api.getReOrgsListForReportGenerator,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function getReOrgAppealTerritoriesListForReportGenerator(){
	const dispatchObj = {
		constants : tableReportsConstants.getReOrgAppealTerritoriesListForReportGenerator,
		service   : {
			func   : api.getReOrgAppealTerritoriesListForReportGenerator
		}
	}
	return defAction(dispatchObj)
}

function getSuperiorOrgsListForReportGenerator(){
	const dispatchObj = {
		constants : tableReportsConstants.getSuperiorOrgsListForReportGenerator,
		service   : {
			func   : api.getSuperiorOrgsListForReportGenerator
		}
	}
	return defAction(dispatchObj)
}

function getReceptionPersonListForReportGenerator(){
	const dispatchObj = {
		constants : tableReportsConstants.getReceptionPersonListForReportGenerator,
		service   : {
			func   : api.getReceptionPersonListForReportGenerator
		}
	}
	return defAction(dispatchObj)
}

function getControlCompleteStatusesListForReportGenerator(values){
	const dispatchObj = {
		constants : tableReportsConstants.getControlCompleteStatusesListForReportGenerator,
		service   : {
			func   : api.getControlCompleteStatusesListForReportGenerator,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getAllReOrgReportSettingsList(params){
	const dispatchObj = {
		constants : tableReportsConstants.getAllReOrgReportSettingsList,
		service   : {
			func   : api.getAllReOrgReportSettingsList,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function getCurrentReOrgReportSetting(params){
	const dispatchObj = {
		constants : tableReportsConstants.getCurrentReOrgReportSetting,
		service   : {
			func   : api.getCurrentReOrgReportSetting,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function createReOrgReportSetting(params){
	const dispatchObj = {
		constants : tableReportsConstants.createReOrgReportSetting,
		service   : {
			func   : api.createReOrgReportSetting,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function updateReOrgReportSetting(params){
	const dispatchObj = {
		constants : tableReportsConstants.updateReOrgReportSetting,
		service   : {
			func   : api.updateReOrgReportSetting,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function deleteReOrgReportSetting(params){
	const dispatchObj = {
		constants : tableReportsConstants.deleteReOrgReportSetting,
		service   : {
			func   : api.deleteReOrgReportSetting,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function clearSettingsListForReportGenerator(){
	return (dispatch) => dispatch({
		type: tableReportsConstants.getSettingsListForReportGenerator.CLEAR
	})
}

function clearCurrentReOrgReportSetting(){
	return (dispatch) => dispatch({
		type: tableReportsConstants.getCurrentReOrgReportSetting.CLEAR
	})
}

function clearCRUDResultForReportGenerator(){
	return (dispatch) => dispatch({
		type: tableReportsConstants.clearCRUDResultForReportGenerator
	})
}

function clearReOrgsListForReportGenerator(){
	return (dispatch) => dispatch({
		type: tableReportsConstants.getReOrgsListForReportGenerator.CLEAR
	})
}

function clearAllReOrgReportSettingsList(){
	return (dispatch) => dispatch({
		type: tableReportsConstants.getAllReOrgReportSettingsList.CLEAR
	})
}

